export const PRODUCT_TYPES = {
  POWER: {
    KEY: 'power',
    NAME: 'Strom',
    ICON: 'Strom',
    TYPES: [
      'power',
      'commodity.electricitys',
      'commodity.power',
      'electricity',
    ],
  },
  GAS: {
    KEY: 'gas',
    NAME: 'Erdgas',
    ICON: 'Erdgas',
    TYPES: [
      'gas',
      'commodity.gas',
    ],
  },
  CAR_POWER: {
    KEY: 'carPower',
    NAME: 'Auto-Strom',
    ICON: 'Auto-Strom',
    TYPES: [
      'emobil',
      'commodity.emobil',
      'carPower',
      'commodity.carPower',
    ],
  },
  POWER_GAS: {
    KEY: 'power,gas',
    NAME: 'Strom & Erdgas',
    ICON: ['Strom', 'Erdgas'],
  },
  DISTRICT_HEATING: {
    KEY: 'districtHeating',
    NAME: 'Fernwärme',
    ICON: 'Fernwärme',
  },
  HEAT: {
    KEY: 'heat',
    NAME: 'Wärmepumpen',
    ICON: 'Wärmepumpen',
  },
  HEATING_POWER: {
    KEY: 'heatingPower',
    NAME: 'Heizstrom',
    ICON: 'Heizstrom',
  },
  POWER_GENERATION_STORAGE: {
    KEY: 'powerGenerationStorage',
    NAME: 'Photovoltaik',
    ICON: 'Photovoltaik',
  },
  CATALOG: {
    KEY: 'catalog',
    NAME: 'Katalogprodukte',
    ICON: 'Katalogprodukte',
  },
  UNKNOWN: {
    KEY: 'unknown',
    NAME: '',
    ICON: '',
  },
};

export const convert = {
  methods: {
    convert(amount, digits = 0) {
      return parseFloat(amount ?? 0).toLocaleString(navigator.language, {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits,
      });
    },
  },
};

export const getProductTitle = {
  methods: {
    productTitle(item) {
      return Object.values(PRODUCT_TYPES).find((type) => type.TYPES?.includes(item))?.NAME || 'Produkt';
    },
  },
};

export const getBonusName = {
  methods: {
    bonusName(bonus) {
      switch (bonus) {
        case 'instant':
          return 'Sofortbonus';
        case 'newCustomer':
          return 'Neukundenbonus';
        case 'action':
          return 'Aktionsbonus';
        case 'other':
          return 'Sonstiger';
        default:
          return 'bonus';
      }
    },
  },
};

export const getBonusValue = {
  methods: {
    bonusValue(bonus) {
      if (Object.keys(bonus).length > 1) {
        const bonuses = [];
        Object.values(bonus).forEach((item) => {
          if (typeof item === 'string' || item instanceof String) {
            bonuses.push(`${item.toString()} %`);
          } else {
            bonuses.push(`${item} €`);
          }
        });
        return bonuses.join(', ');
      }
      switch (Object.keys(bonus).toString()) {
        case 'percentage':
          return `${Object.values(bonus)} %`;
        default:
          return `${this.convert(Object.values(bonus), 2)} €`;
      }
    },
  },
};

export const ftpStates = {
  data() {
    return {
      ftpType: 'ftp',
      states: [
        {
          value: 'ftps',
          label: 'FTPS',
        },
        {
          value: 'ftp',
          label: 'FTP',
        },
        {
          value: 'sftp',
          label: 'SFTP',
        },
      ],
    };
  },
};

export const updateItemErrorClear = {
  methods: {
    updateItem([key, value, obj]) {
      if (obj) {
        if (obj.includes('.')) {
          const path = obj.split('.');
          this.errors.clear(`${path[0]}.${path[1]}.${key}`);
          this[path[0]][path[1]][key] = value;
        } else {
          this.errors.clear(`${obj}.${key}`);
          this[obj][key] = value;
        }
      } else {
        this.errors.clear(key);
        this[key] = value;
      }
    },
  },
};
